// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-card > .card-body[data-v-cf4e45dc] {\n  height: calc(100% - 150px);\n}\n.action-box .grid-container-2 .grid-item-4[data-v-cf4e45dc] {\n  grid-column: span 4;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
